import React, {useEffect, useState} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Icon from '../../../../components/icon';
import Loader from '../../../../components/sprite/components/loader';
import ContactDetailsHead from './components/contact-details-head';
import ContactDetailsBody from './components/contact-details-body';
import ContactInfoOptions
	from "../sharing-details-popup/components/contact-details-popup/components/contact-info/components/contact-info-options";
import { getSelectedContactsGroup } from '../../../../../actions/contactsGroupItemActions';
import './index.css';
import AiButton from '../../../../components/ai-button';
import {isContactWithAiPopupShown} from '../../../../../actions/popupActions';

function ContactDetails ({history, location}) {

	const [isLoading, setIsLoading] = useState(true);

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);
	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	const { t } = useTranslation();

	useEffect(() => {
		if(contactDetails !== null){
			setIsLoading(false);
		}
	}, [contactDetails]);

	useEffect(() => {
		if(selectedContactsGroup === null){
			if(contactDetails.labels.length > 0){
				dispatch(getSelectedContactsGroup({
					'id' : contactDetails.labels[0].id,
					'name' : contactDetails.labels[0].name,
					'status' : contactDetails.labels[0].status,
					'permission' : contactDetails.labels[0].permission,
					'type' : contactDetails.labels[0].id === "6" ? "system" : "contact",
					'activeDirectory' : contactDetails.labels[0].activeDirectory,
					'ownerId': contactDetails.labels[0].id === "6" ? profile.id : contactDetails.labels[0].ownerId,
					'ownerName': contactDetails.labels[0].ownerName,
					'parentId' : contactDetails.labels[0].parentId ? contactDetails.labels[0].parentId : null,
					'parentName' : contactDetails.labels[0].parentName ? contactDetails.labels[0].parentName : null,
					'index': contactDetails.labels[0].index,
					'directorySyncType': contactDetails.labels[0].directorySyncType,
					'directorySyncStatus': contactDetails.labels[0].directorySyncStatus,
					'directoryDisplayStatus': contactDetails.labels[0].directoryDisplayStatus,
					'customerId': contactDetails.labels[0].customerId
				}));
			}
		}
	}, [dispatch, profile, contactDetails, selectedContactsGroup]);

	/*useEffect(() => {
		if(!isLabelFound) {
			dispatch(getSelectedContactsGroup({
				'id' : contactDetails.labels[0].id === "6" ? contactDetails.labels[0].id + '-' + profile.id : contactDetails.labels[0].id,
				'name' : contactDetails.labels[0].name,
				'status' : contactDetails.labels[0].status,
				'permission' : contactDetails.labels[0].permission,
				'type' : contactDetails.labels[0].id === "6" ? "system" : "contact",
				'activeDirectory' : contactDetails.labels[0].activeDirectory,
				'ownerId': contactDetails.labels[0].id === "6" ? profile.id : contactDetails.labels[0].ownerId,
				'ownerName': contactDetails.labels[0].ownerName,
				'index': contactDetails.labels[0].index,
				'directorySyncType': contactDetails.labels[0].directorySyncType,
				'directorySyncStatus': contactDetails.labels[0].directorySyncStatus,
				'directoryDisplayStatus': contactDetails.labels[0].directoryDisplayStatus,
				'customerId': contactDetails.labels[0].customerId
			}));
		}
	}, [dispatch, isLabelFound, profile, contactDetails])*/

	if(isLoading) {
		return (
			<Loader/>
		)
	} else {
		return (
			<div className={`contact-details${location.pathname === "/contact/" + contactDetails.id + "/edit" ? ' edit-mode' : ''}`}>
				<div className="d-flex align-items-center justify-content-between">
					{
						selectedContactsGroup && <NavLink
							to={`/label/${selectedContactsGroup.id === '6' ? selectedContactsGroup.id + '-' + selectedContactsGroup.ownerId : selectedContactsGroup.id}`}
							className="btn-link p-0"
						>
							<Icon name="long-arrow-left" className="mr-2"/> {t("getBackText")}
						</NavLink>
					}
					<AiButton disabled={contactDetails.editable === false} onClick={() => dispatch(isContactWithAiPopupShown({action:'edit', tab:'voice'}))} className="ml-auto">
						{t('editContactWithAiBtn')}
					</AiButton>
					<ContactInfoOptions location={location} contactDetails={contactDetails}/>
				</div>
				{
					(
						location.pathname !== "/contact/" + contactDetails.id + '/edit'
						&& location.pathname !== "/contact/" + contactDetails.id + '/history'
					) &&
					<ContactDetailsHead contactDetails={contactDetails} selectedContactsGroup={selectedContactsGroup}/>
				}
				<ContactDetailsBody contactDetails={contactDetails} history={history} location={location} />
			</div>
		)
	}

}

export default withRouter(ContactDetails);
